import { Device, Organization, SimpleSubscription } from "@models";
import { CreateDeviceUiState } from "@types";
import { useState } from "react";
import { MyDeviceModalContent } from "./MyDeviceModalContent";

interface EditDeviceModalContentProps {
  device: Device;
  subscription: SimpleSubscription;
  org: Organization;
  setEditDevice: (editDevice: boolean) => void;
  devices: Device[];
}

export const EditDeviceModalContent = ({
  device,
  subscription,
  org,
  setEditDevice,
  devices,
}: EditDeviceModalContentProps) => {
  const [newDevice, setNewDevice] = useState<CreateDeviceUiState>({
    name: device.name,
    description: device.description,
    isFDA: device.isFDA,
    isMDR: device.isMDR,
    isIVDR: device.isIVDR,
    components: device.components.map((component, index) => ({
      ...component,
      index: index + 1,
      collapsed: false,
      subComponents: component.subComponents.map((subComponent, subIndex) => ({
        ...subComponent,
        index: subIndex + 1,
      })),
    })),
  });

  return (
    <MyDeviceModalContent
      subscription={subscription}
      devices={devices}
      org={org}
      setNewDevice={setNewDevice}
      newDevice={newDevice}
      deviceIsAiGenerated={false}
      device={device}
      setEditDevice={setEditDevice}
    />
  );
};
